/** How long between clock checks. Also the countdown's tick. */
export const SESSION_TICK_MS = 1000;

/** How long before expiry the warning appears, clamped for very short timeouts. */
export const WARNING_LEAD_MS = 60000;

/** Upper bound on how often activity is written to localStorage for other tabs. */
export const ACTIVITY_WRITE_THROTTLE_MS = 5000;

/** The only user type this site signs in, and so the only configuration it reads. */
export const ECOMMERCE_USER_TYPE = 'ECOMMERCE';

export type ExpiryReason = 'idle' | 'absolute';

export type SessionPhase = 'active' | 'warning';

export interface ResolvedSessionTimeouts {
  /** False whenever the company has not turned automatic sign-out on. */
  enabled: boolean;
  /** Milliseconds of inactivity before sign-out. 0 disables the idle deadline. */
  idleMs: number;
  /** Milliseconds from session start before sign-out. 0 disables the cap. */
  absoluteMs: number;
}

export interface SessionTimeoutState {
  phase: SessionPhase;
  reason: ExpiryReason | null;
  secondsRemaining: number;
  /** False for the absolute cap, which activity cannot extend. */
  canExtend: boolean;
  onStaySignedIn: () => void;
  onSignOutNow: () => void;
}

export interface SessionTimeoutWarningModalProps {
  reason: ExpiryReason;
  secondsRemaining: number;
  canExtend: boolean;
  onStaySignedIn: () => void;
  onSignOutNow: () => void;
}

export interface SessionTimeoutHookProps {
  /** Bare company id, used to look up the policy and to scope the stored session records. */
  companyId: string;
  /** `${companyId}::${userId}` — scopes the absolute window to one customer on one tenant. */
  userKey: string;
  signOut: () => Promise<void>;
}
